export default (api) => ({
  getMerchantLedgerInfo: (merchantId) => api.get(`/ledgers/merchant/${merchantId}/info`),
  createNewLedger: (merchantId, body) => api.post(`/ledgers/merchant/${merchantId}`, body),
  getPreviousEntries: (merchantId, params) => api.get(`/ledgers/merchant/${merchantId}`, { params }),
  toggleLedgerDisplay: (merchantId, ledgerId, display) => api.patch(`/ledgers/merchant/${merchantId}/toggle/${ledgerId}/display`, { display }),
  toggleLedgerReport: (merchantId, ledgerId, report) => api.patch(`/ledgers/merchant/${merchantId}/toggle/${ledgerId}/report`, { report })
})
